
































import Vue from "vue";
import coreApiClient from "@/services/apis/coreApiClient";
import userManager from "@/services/userManager";
import { encode } from "@common/util/base64Util";

export default Vue.extend({
  data() {
    const that = this as any;
    return {
      tableOptions: {
        attrs: {
          "item-key": "_id",
          "sort-by": "_id",
          "sort-desc": false,
        },
        content: {
          name: "Cashback",
          urlEnabled: true,
          search: {
            ext: {
              hidden: true,
            },
          },
          filters: {
            filters: {
              tenantId: userManager.checkRole(["systemAdmin", "admin"]) && {
                type: "XAutocomplete",
                attrs: {
                  label: "Organization",
                  required: true,
                  "item-value": "_id",
                  "item-text": "name",
                  xOptions: {
                    content: {
                      async itemsSuggestor(search, value, limit) {
                        const { items } = await coreApiClient.call("tenants", "findAll", {
                          payload: JSON.stringify({
                            limit,
                            search,
                            orderBy: "name",
                            orderType: "asc",
                            filters: [
                              {
                                key: "_id",
                                operator: "equal_to",
                                value,
                              },
                            ],
                          }),
                        });
                        return items;
                      },
                    },
                  },
                },
                rules: {
                  equal_to: {},
                },
              },
            },
          },
           displayFields: {
             tenant: userManager.checkRole(["systemAdmin", "admin", "cpoGroup"]) && {
               text: "Organization",
               options: {
                 subProp: "tenant.name",
                 transform: (value, row) => {
                   // For roaming_out mode, show ocpiData.session.party_id if no tenant
                   if (that.$route?.meta?.ocpiMode === "roaming_out" && !row.tenant && row.ocpiData?.session?.party_id) {
                     return row.ocpiData.session.party_id;
                   }
                   // Default to tenant.name
                   return value || "N/A";
                 },
                 to: (value, row) => {
                   const ocpiModeMeta = that.$route?.meta?.ocpiMode;
                   const base = ocpiModeMeta === "roaming_in"
                       ? "cashback_roaming_in/"
                       : ocpiModeMeta === "roaming_out"
                         ? "cashback_roaming_out/"
                         : "cashback/";
                   const filtersOrganization = {
                     "customPerPage": 0,
                     "dataOptions": {
                       "groupBy": [],
                       "groupDesc": [],
                       "itemsPerPage": 50,
                       "multiSort": false,
                       "mustSort": false,
                       "page": 1,
                       "sortBy": [
                         "tenant.name"
                       ],
                       "sortDesc": [
                         false
                       ]
                     },
                     "filters": [
                       {
                         "key": "point",
                         "operator": "greater_than",
                         "value": 0
                       }
                     ]
                   };
                   return base + row._id + '?table_options=' + encode(JSON.stringify(filtersOrganization));
                 },
               },
             },
             powerConsumption: {
               text: "Power Consumption (kWh)",
               sortable: true,
             },
             electricityTariff: {
               text: "Electricity Tariff",
               sortable: true,
             },
             powerCost: {
               text: "Power Cost (VND)",
               sortable: true,
             },
             totalPoints: {
               text: "Revenue (VND)",
               sortable: true,
             },
             netRevenue: {
               text: "Net Revenue (VND)",
               sortable: true,
             },
             ratio: {
               text: "Ratio",
               sortable: true,
             },
             partnerRevenue: {
               text: "Partner Revenue (VND)",
               sortable: true,
             },
           },
        },
        ext: {
          dataProvider: {
            async findAll(options) {
               // For local cashback (default route), use 'local' as ocpiMode
               // For roaming routes, use the meta ocpiMode
               let ocpiModeMeta = that.$route?.meta?.ocpiMode as string | undefined;
               if (!ocpiModeMeta) {
                 ocpiModeMeta = 'local'; // Default to 'local' for the main cashback route
               }
               console.log('Cashback findAll - ocpiMode:', ocpiModeMeta, 'route:', that.$route?.path);
               
               const apiOptions = { ...(options || {}) };
               // Always add ocpiMode parameter
               apiOptions.ocpiMode = ocpiModeMeta;
               console.log('Cashback findAll - apiOptions with ocpiMode:', apiOptions);
              
              const { items, count } = await coreApiClient.call("cashBacks", "statics", apiOptions);
              return [items, count];
            },
          },
          dataOptions: {
            itemsPerPage: 50,
            page: 1,
            multiSort: false,
            mustSort: false,
            groupBy: [],
            groupDesc: []
          },
        },
      },
    };
  },
});

